import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Footer from "../../components/Footer";
import ModalNotificacaoPopUp from "../../components/ModalNotificacaoPopUp";
import { usePermissoesLocalStorage } from "../../utils/usePermissoesLocalStorage";
import { obterStorage } from "../../utils/secureStorage";

function Home() {
  const navigate = useNavigate();
  const { verificarPermissao } = usePermissoesLocalStorage();
  const permissoesDashboard = verificarPermissao("CONS_DASHBOARD");

  useEffect(() => {
    try {
      const sessao = obterStorage("sessao");

      if (["PLATAFORMA", "INTEGRADOR"].includes(sessao?.empresaDTO?.tipoEmpresa)) {
        return;
      }

      if (!permissoesDashboard.consultar) {
        return;
      }

      let urlMenuPadrao = "";

      const dashboards = obterStorage("lista_dashboards");

      if (dashboards == null || dashboards == "") {
        return;
      }

      dashboards.map((item) => {
        if (item.padrao) {
          urlMenuPadrao = `/dashboard/${item.urlAmigavel}`;
        }
      });

      if (urlMenuPadrao == "") {
        toast.info("Nenhum Dashboard selecionado como padrão");
        urlMenuPadrao = `/dashboard/${dashboards[0].urlAmigavel}`;
      }

      navigate(urlMenuPadrao);
    } catch (e) {}
  }, []);

  function CorpoPagina() {
    return (
      <>
        <ModalNotificacaoPopUp />
        <Footer caminho={["Dashboard"]} />
      </>
    );
  }

  return CorpoPagina();
}

export default Home;
